export default {
  namespaced: true,
  state: {
    showGoodVatSummaryTutorial: true,
    showPersonTypeTutorial: true,
    showIncomeRateTutorial: true,
  },
  mutations: {
    setValue(state, obj) {
      state[obj.name] = obj.value;
    },
  },
  actions: {
    addValue(context, obj) {
      context.commit("setValue", obj);
    },
  },
  getters: {
    getApp(state) {
      return state;
    },
  },
};
